export default function PomEmpty({ message = "Nothing here yet" }) {
  return (
    <div
      className="flex flex-col items-center justify-center py-16 px-4"
      data-testid="pom-empty-state"
    >
      <div className="relative mb-6">
        <img
          src="/pomeranian.png"
          alt="Waimbow waiting"
          className="w-28 h-28 object-contain animate-pom-breathe drop-shadow-sm"
        />
        {/* Floating hearts */}
        <span className="absolute -top-1 -right-1 text-blush animate-pom-float text-sm opacity-70">
          &hearts;
        </span>
        <span
          className="absolute top-2 -left-2 text-blush animate-pom-float text-xs opacity-50"
          style={{ animationDelay: "1s" }}
        >
          &hearts;
        </span>
      </div>
      <p className="text-text-secondary text-sm text-center font-sans max-w-[240px]">
        {message}
      </p>
    </div>
  );
}
